var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.8A1.8 1.8 0 0 1 1.8 1h14.4A1.8 1.8 0 0 1 18 2.8v9.9a1.8 1.8 0 0 1-1.8 1.8h-4.5l-2.382 2.382a.45.45 0 0 1-.636 0L6.3 14.5H1.8A1.8 1.8 0 0 1 0 12.7V2.8z",
    fill: "#5670D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72 8.668c0-.212.07-.387.208-.525a.691.691 0 0 1 .525-.22c.333 0 .634-.049.903-.146a1.34 1.34 0 0 0 .635-.5c.162-.229.244-.53.244-.904 0-.277-.07-.52-.208-.732a1.364 1.364 0 0 0-.549-.5 1.628 1.628 0 0 0-.781-.184c-.228 0-.444.04-.647.122a2.03 2.03 0 0 0-.537.33c-.13.114-.29.199-.476.256-.18.049-.362.004-.55-.134-.195-.147-.3-.322-.317-.525-.016-.204.061-.39.232-.562a3.055 3.055 0 0 1 1.025-.695c.4-.171.822-.257 1.27-.257.561 0 1.066.13 1.513.39.456.253.818.595 1.087 1.026.268.431.403.92.403 1.465 0 .407-.061.769-.183 1.086a2.34 2.34 0 0 1-.525.806c-.22.22-.48.399-.782.537-.293.13-.614.224-.964.28l-.049.025c-.008.008-.012.02-.012.037v.451c0 .212-.07.391-.207.537a.711.711 0 0 1-.525.208.711.711 0 0 1-.525-.207.753.753 0 0 1-.208-.538v-.927zm.672 3.857c-.236 0-.42-.061-.55-.183-.122-.13-.183-.313-.183-.55v-.207c0-.236.061-.415.183-.537.13-.13.314-.195.55-.195h.158c.236 0 .415.065.537.195.13.122.196.301.196.537v.208c0 .236-.065.419-.196.549-.122.122-.3.183-.537.183h-.158z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.3221854ffeaadad508f9250c4e248f57.svg";
export { ForwardRef as ReactComponent };